export const ResidentParams = [
     "id"
    , "name"
    , "roomName"
    , "status"
    , "wingName"
    , "wingId"
    , "imageUrl"
    , "thumbnailUrl"
    , "checkInTime"
    , "shortDob"
    , "facilityId"
    , "mediaAppOverrides"
    , "accessesOnMyhub"
    , "createdDateTime"
    , "departedTime"
    , "dateOfBirth"
    , "refId"
    , "isUsingOwnDevice"
    , "isUsingMyHub"
    , "email"
    , "pname"
    , "veteranStatus"
    , "interestsTags"
    , "preferencesTags"
    , "backgroundTags"
    , "address"
    , "phone"
    , "familyHubUsersIds"
]